import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

// Зачистка устаревшего runtime-кэша SW: 'wave-refs' (StaleWhileRevalidate на
// /api/v1/ref/) убран из vite.config.ts, но у уже обновившихся клиентов кэш
// остаётся в Cache Storage. Строку можно удалить после полного выката.
if ('caches' in window) void caches.delete('wave-refs');

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
